import React, { createContext, useContext, useState, useCallback } from 'react'
import { NotificationToastData } from '@components/common/NotificationToast/NotificationToast.component'

interface NotificationToastContextType {
  showToast: (notification: NotificationToastData) => void
  toasts: NotificationToastData[]
  removeToast: (id: string) => void
}

const NotificationToastContext = createContext<
  NotificationToastContextType | undefined
>(undefined)

export const useNotificationToast = (): NotificationToastContextType => {
  const context = useContext(NotificationToastContext)
  if (!context) {
    throw new Error(
      'useNotificationToast must be used within NotificationToastProvider',
    )
  }
  return context
}

interface NotificationToastProviderProps {
  children: React.ReactNode
}

export const NotificationToastProvider: React.FC<
  NotificationToastProviderProps
> = ({ children }) => {
  const [toasts, setToasts] = useState<NotificationToastData[]>([])

  const showToast = useCallback((notification: NotificationToastData) => {
    setToasts((prev) => [...prev, notification])
  }, [])

  const removeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id))
  }, [])

  return (
    <NotificationToastContext.Provider
      value={{ showToast, toasts, removeToast }}
    >
      {children}
    </NotificationToastContext.Provider>
  )
}
